/*
 * groupEntities Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import {
    GROUP_CREATE_SUCCEEDED,
    GROUP_UPDATE_SUCCEEDED,
    GROUP_DELETE_SUCCEEDED
} from '../groups/constants';
import { RESET_STATE } from '../auth/constants';

const initialState = [];

export default function(state = initialState, action) {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'response.groupEntities', []);
        case GROUP_CREATE_SUCCEEDED: {
            const groupEntities = get(action, 'response.entities', []);
            return state.concat(groupEntities);
        }
        case GROUP_UPDATE_SUCCEEDED: {
            const groupEntities = get(action, 'response.entities', []);
            return state
                .filter(value => value.groupId !== Number(action.id))
                .concat(groupEntities);
        }
        case GROUP_DELETE_SUCCEEDED: {
            return state.filter(value => value.groupId !== Number(action.id));
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
